import { Builder } from "@builder.io/sdk";

import "@/components/Builder/Typography/Heading/Heading";
import "@/components/Builder/Typography/Text/Text";

import { V2_HEADING, V2_TEXT } from "./component-names";

Builder.register("insertMenu", {
  name: "Typography",
  items: [{ name: V2_HEADING }, { name: V2_TEXT }],
});
